export default __webpack_public_path__ + "static/media/logo-white.3bb6b432.svg";